// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
    max-width: 980px;
    margin: 0 auto;
    min-height: 100vh;
    color: #3d3128;
    font-family: 'appFont', 'Songti SC', 'STSong', 'SimSun', serif;
    background: #fbf7f0;
}

.home-hero {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 48px 20px 40px;
    text-align: center;
    background:
        radial-gradient(circle at 20% 10%, rgba(195, 160, 123, 0.18), transparent 45%),
        radial-gradient(circle at 85% 90%, rgba(195, 160, 123, 0.14), transparent 40%),
        linear-gradient(180deg, #f3ead9 0%, #fbf7f0 100%);
}

.home-icon {
    width: 96px;
    height: 96px;
    margin-bottom: 20px;
    border-radius: 22%;
    box-shadow: 0 10px 24px rgba(61, 49, 40, 0.18);
}

.home-brand {
    margin: 0;
    font-size: 36px;
    letter-spacing: 4px;
    color: #3d3128;
}

.home-slogan {
    margin: 8px 0 0;
    font-size: 17px;
    letter-spacing: 2px;
    color: #a0773f;
}

.home-sub {
    max-width: 340px;
    margin: 14px auto 0;
    font-size: 15px;
    line-height: 1.8;
    color: #6f5d4e;
}

.home-downloads {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    width: 100%;
    max-width: 340px;
    margin-top: 26px;
}

.home-download {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 48px;
    padding: 12px 24px;
    border-radius: 24px;
    font-size: 16px;
    letter-spacing: 2px;
    text-decoration: none;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.home-download:active {
    transform: scale(0.98);
}

.home-download-ios {
    color: #fff;
    background: linear-gradient(135deg, #b98a4e 0%, #8f6533 100%);
    box-shadow: 0 6px 16px rgba(143, 101, 51, 0.35);
}

.home-download-android {
    color: #3d3128;
    border: 1.5px solid #b98a4e;
    background: rgba(255, 255, 255, 0.65);
}

.home-features,
.home-shots,
.home-about {
    padding: 44px 20px;
}

.home-section-title {
    margin: 0 0 24px;
    font-size: 24px;
    letter-spacing: 3px;
    text-align: center;
    color: #3d3128;
}

.home-section-title::after {
    display: block;
    width: 44px;
    height: 3px;
    margin: 12px auto 0;
    border-radius: 2px;
    background: linear-gradient(90deg, #c3a07b, #8f6533);
    content: '';
}

.home-feature-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 14px;
}

.home-feature {
    padding: 20px 18px;
    border: 1px solid rgba(195, 160, 123, 0.35);
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0 4px 12px rgba(61, 49, 40, 0.05);
}

.home-feature h3 {
    margin: 0 0 8px;
    font-size: 18px;
    color: #8f6533;
}

.home-feature p {
    margin: 0;
    font-size: 14px;
    line-height: 1.8;
    color: #6f5d4e;
}

.home-shot-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.home-shot {
    width: min(240px, 72vw);
    border: 1px solid rgba(195, 160, 123, 0.35);
    border-radius: 18px;
    box-shadow: 0 12px 28px rgba(61, 49, 40, 0.16);
}

.home-about {
    background: linear-gradient(180deg, #f3ead9 0%, #fbf7f0 100%);
}

.home-about p {
    max-width: 720px;
    margin: 0 auto 16px;
    font-size: 15px;
    line-height: 2;
    text-align: justify;
    color: #6f5d4e;
}

.home-disclaimer {
    font-size: 13px !important;
    color: #9a8a79 !important;
}

.home-footer {
    padding: 28px 20px;
    border-top: 1px solid rgba(195, 160, 123, 0.3);
    text-align: center;
    background: #f3ead9;
}

.home-footer p {
    margin: 4px 0;
    font-size: 13px;
    letter-spacing: 1px;
    color: #8c7a68;
}

.home-icp a {
    color: #8c7a68;
    text-decoration: none;
}

.home-icp a:hover {
    text-decoration: underline;
}

@media (min-width: 600px) {
    .home-downloads {
        flex-direction: row;
        justify-content: center;
        max-width: none;
    }

    .home-download {
        min-width: 180px;
    }

    .home-feature-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .home-shot-list {
        flex-direction: row;
        justify-content: center;
        gap: 24px;
    }

    .home-shot {
        width: 200px;
    }
}

@media (min-width: 980px) {
    .home-hero {
        flex-direction: row;
        justify-content: center;
        gap: 56px;
        padding: 72px 40px 64px;
        text-align: left;
    }

    .home-icon {
        width: 128px;
        height: 128px;
    }

    .home-hero-text {
        max-width: 520px;
    }

    .home-sub {
        margin-left: 0;
    }

    .home-downloads {
        justify-content: flex-start;
    }

    .home-features,
    .home-shots,
    .home-about {
        padding: 64px 40px;
    }

    .home-feature-grid {
        grid-template-columns: repeat(4, 1fr);
    }

    .home-shot {
        width: 240px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/index.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,8DAA8D;IAC9D,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB;;;yDAGqD;AACzD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;AAC3D;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,6DAA6D;IAC7D,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,oDAAoD;IACpD,WAAW;AACf;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,oCAAoC;IACpC,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,2CAA2C;IAC3C,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,8CAA8C;IAC9C,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,mBAAmB;QACnB,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,uBAAuB;QACvB,SAAS;QACT,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;;;QAGI,kBAAkB;IACtB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".home {\n    max-width: 980px;\n    margin: 0 auto;\n    min-height: 100vh;\n    color: #3d3128;\n    font-family: 'appFont', 'Songti SC', 'STSong', 'SimSun', serif;\n    background: #fbf7f0;\n}\n\n.home-hero {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 48px 20px 40px;\n    text-align: center;\n    background:\n        radial-gradient(circle at 20% 10%, rgba(195, 160, 123, 0.18), transparent 45%),\n        radial-gradient(circle at 85% 90%, rgba(195, 160, 123, 0.14), transparent 40%),\n        linear-gradient(180deg, #f3ead9 0%, #fbf7f0 100%);\n}\n\n.home-icon {\n    width: 96px;\n    height: 96px;\n    margin-bottom: 20px;\n    border-radius: 22%;\n    box-shadow: 0 10px 24px rgba(61, 49, 40, 0.18);\n}\n\n.home-brand {\n    margin: 0;\n    font-size: 36px;\n    letter-spacing: 4px;\n    color: #3d3128;\n}\n\n.home-slogan {\n    margin: 8px 0 0;\n    font-size: 17px;\n    letter-spacing: 2px;\n    color: #a0773f;\n}\n\n.home-sub {\n    max-width: 340px;\n    margin: 14px auto 0;\n    font-size: 15px;\n    line-height: 1.8;\n    color: #6f5d4e;\n}\n\n.home-downloads {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    width: 100%;\n    max-width: 340px;\n    margin-top: 26px;\n}\n\n.home-download {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 48px;\n    padding: 12px 24px;\n    border-radius: 24px;\n    font-size: 16px;\n    letter-spacing: 2px;\n    text-decoration: none;\n    transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.home-download:active {\n    transform: scale(0.98);\n}\n\n.home-download-ios {\n    color: #fff;\n    background: linear-gradient(135deg, #b98a4e 0%, #8f6533 100%);\n    box-shadow: 0 6px 16px rgba(143, 101, 51, 0.35);\n}\n\n.home-download-android {\n    color: #3d3128;\n    border: 1.5px solid #b98a4e;\n    background: rgba(255, 255, 255, 0.65);\n}\n\n.home-features,\n.home-shots,\n.home-about {\n    padding: 44px 20px;\n}\n\n.home-section-title {\n    margin: 0 0 24px;\n    font-size: 24px;\n    letter-spacing: 3px;\n    text-align: center;\n    color: #3d3128;\n}\n\n.home-section-title::after {\n    display: block;\n    width: 44px;\n    height: 3px;\n    margin: 12px auto 0;\n    border-radius: 2px;\n    background: linear-gradient(90deg, #c3a07b, #8f6533);\n    content: '';\n}\n\n.home-feature-grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 14px;\n}\n\n.home-feature {\n    padding: 20px 18px;\n    border: 1px solid rgba(195, 160, 123, 0.35);\n    border-radius: 14px;\n    background: rgba(255, 255, 255, 0.8);\n    box-shadow: 0 4px 12px rgba(61, 49, 40, 0.05);\n}\n\n.home-feature h3 {\n    margin: 0 0 8px;\n    font-size: 18px;\n    color: #8f6533;\n}\n\n.home-feature p {\n    margin: 0;\n    font-size: 14px;\n    line-height: 1.8;\n    color: #6f5d4e;\n}\n\n.home-shot-list {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n}\n\n.home-shot {\n    width: min(240px, 72vw);\n    border: 1px solid rgba(195, 160, 123, 0.35);\n    border-radius: 18px;\n    box-shadow: 0 12px 28px rgba(61, 49, 40, 0.16);\n}\n\n.home-about {\n    background: linear-gradient(180deg, #f3ead9 0%, #fbf7f0 100%);\n}\n\n.home-about p {\n    max-width: 720px;\n    margin: 0 auto 16px;\n    font-size: 15px;\n    line-height: 2;\n    text-align: justify;\n    color: #6f5d4e;\n}\n\n.home-disclaimer {\n    font-size: 13px !important;\n    color: #9a8a79 !important;\n}\n\n.home-footer {\n    padding: 28px 20px;\n    border-top: 1px solid rgba(195, 160, 123, 0.3);\n    text-align: center;\n    background: #f3ead9;\n}\n\n.home-footer p {\n    margin: 4px 0;\n    font-size: 13px;\n    letter-spacing: 1px;\n    color: #8c7a68;\n}\n\n.home-icp a {\n    color: #8c7a68;\n    text-decoration: none;\n}\n\n.home-icp a:hover {\n    text-decoration: underline;\n}\n\n@media (min-width: 600px) {\n    .home-downloads {\n        flex-direction: row;\n        justify-content: center;\n        max-width: none;\n    }\n\n    .home-download {\n        min-width: 180px;\n    }\n\n    .home-feature-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .home-shot-list {\n        flex-direction: row;\n        justify-content: center;\n        gap: 24px;\n    }\n\n    .home-shot {\n        width: 200px;\n    }\n}\n\n@media (min-width: 980px) {\n    .home-hero {\n        flex-direction: row;\n        justify-content: center;\n        gap: 56px;\n        padding: 72px 40px 64px;\n        text-align: left;\n    }\n\n    .home-icon {\n        width: 128px;\n        height: 128px;\n    }\n\n    .home-hero-text {\n        max-width: 520px;\n    }\n\n    .home-sub {\n        margin-left: 0;\n    }\n\n    .home-downloads {\n        justify-content: flex-start;\n    }\n\n    .home-features,\n    .home-shots,\n    .home-about {\n        padding: 64px 40px;\n    }\n\n    .home-feature-grid {\n        grid-template-columns: repeat(4, 1fr);\n    }\n\n    .home-shot {\n        width: 240px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
